var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goDeheShow)?_c('div',{staticClass:"go-dehe",on:{"click":_vm.onClickLeft}}):(_vm.goSalesman)?_c('div',{staticClass:"go-salesman",on:{"click":_vm.salesman}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }